// import * as dis from './'
// import Description from './Description.vue'
import Zdisplay from './ZDisplay.vue'

// Description.install = Vue => {
//     Vue.component('DescriptionList', Description)
// }

Zdisplay.install = Vue => {
    Vue.component('ZDisplay', Zdisplay)
}

export default Zdisplay



// WEBPACK FOOTER //
// ./src/components/description/index.js